(function () {
    "use strict"
    realmCommerceApp.run(run);

    /*@ngInject*/
    function run($locale, ENVIRONMENT) {
        $locale.NUMBER_FORMATS.CURRENCY_SYM = ENVIRONMENT.currencySymbol;
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/config/environment.config.js